import "./Footer.css"
function Footer(){
    return(
    <div className="footer">
        <div className="copy-right text-center">
            <p>Copyright© 2022 Booklet. All Rights Reserved.</p>
            <p>Developed By: <a href="https://github.com/msasif2000/Booklet.git" >Shahin and Asif</a></p>
        </div>
    </div>
    );
}
export default Footer;